import { AuthRoutes } from "./routes";
import { ApiClient } from "@/api/v2/api";
import { LoginCredentials, User } from "@/types/v2";
import { AxiosError } from "axios";
import router from "@/router/v2";

interface LoginResponse {
  status: string;
  token: string;
  token_expires: string;
  user: User;
}

const AuthService = {
  async login(credentials: LoginCredentials): Promise<LoginResponse> {
    try {
      const response = await ApiClient.post<LoginResponse>(
        AuthRoutes.LOGIN,
        credentials
      );
      return response.data;
    } catch (error: unknown) {
      if (error instanceof AxiosError) {
        throw error.response?.data || error;
      }
      throw error;
    }
  },

  async logout(): Promise<void> {
    await ApiClient.post(AuthRoutes.LOGOUT);
    await router.push("/");
  },

  async isAuthenticated(): Promise<boolean> {
    try {
      await ApiClient.get(AuthRoutes.IS_AUTHENTICATED);
      return true;
    } catch (error) {
      return false;
    }
  },
};

export default AuthService;
